import React, { type ReactElement } from 'react';

import { HelperMessage } from '@atlaskit/form/helper-message';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const helperMessageWrapperStyles = xcss({
	marginBottom: 'space.100',
	display: 'flex',
	justifyContent: 'space-between',
});

const helperMessageDisabledStyles = xcss({
	color: 'color.text.disabled',
});

export const MediaContentHelperMessage = ({
	helperMessage,
	isDisabled,
}: {
	helperMessage: string | ReactElement | undefined;
	isDisabled: boolean | undefined;
}): React.JSX.Element | null =>
	helperMessage ? (
		<Box xcss={helperMessageWrapperStyles}>
			<HelperMessage>
				<Box xcss={isDisabled ? helperMessageDisabledStyles : undefined}>{helperMessage}</Box>
			</HelperMessage>
		</Box>
	) : null;
